"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _shared = require("@widget-editor/shared");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _vizzualityComponents = require("vizzuality-components");

var _actions = require("@widget-editor/shared/lib/modules/editor/actions");

var _actions2 = require("@widget-editor/shared/lib/modules/configuration/actions");

var _layerManager = _interopRequireDefault(require("./helpers/layer-manager"));

var _constants = require("./constants");

var _chromaJs = _interopRequireDefault(require("chroma-js"));

var _styleConstants = require("@widget-editor/shared/lib/styles/style-constants");

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // vizzuality-components icons


var DEFAULT_MAP_PROPERTIES = {
  zoom: 2,
  lat: 0,
  lng: 0,
  bbox: [0, 0, 0, 0],
  basemap: {
    basemap: "dark"
  }
};
var MAP_CONFIG = {
  minZoom: 2,
  zoomControl: true
};

var StyledLegend = _styledComponents["default"].div.withConfig({
  displayName: "src__StyledLegend",
  componentId: "sc-1tumy4l-0"
})(["position:absolute;bottom:35px;right:30px;width:80%;max-width:400px;background:", ";border-radius:4px;"], _styleConstants.COLOR_WHITE);

var Map =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(Map, _react$default$Compon);

  function Map(props) {
    var _this;

    _classCallCheck(this, Map);

    var _this$mapConfiguratio;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Map).call(this, props));
    _this.state = {
      loading: false,
      legendOpen: true
    };
    _this.labels = props.labels || _constants.LABELS["none"];
    _this.mapConfiguration = (props === null || props === void 0 ? void 0 : props.mapConfiguration) ? props.mapConfiguration : DEFAULT_MAP_PROPERTIES;
    _this.layers = props.layers;
    _this.layerGroups = _this.createLayerGroups(_this.layers, props.layerId);

    if (_this.mapConfiguration.basemap) {
      _this.basemap = _constants.BASEMAPS[_this.mapConfiguration.basemap.basemap];
    } else {
      _this.basemap = _constants.BASEMAPS.dark;
    }

    if ((_this$mapConfiguratio = _this.mapConfiguration.basemap) === null || _this$mapConfiguratio === void 0 ? void 0 : _this$mapConfiguratio.labels) {
      _this.labels = _constants.LABELS[_this.mapConfiguration.basemap.labels];
    }

    return _this;
  }

  _createClass(Map, [{
    key: "createLayerGroups",
    value: function createLayerGroups(layers, layerId) {
      if (!(layers === null || layers === void 0 ? void 0 : layers.length)) {
        return [];
      }

      return layers.map(function (_ref) {
        var id = _ref.id,
            attributes = _ref.attributes;
        return {
          dataset: attributes.dataset,
          visible: true,
          layers: [_objectSpread({
            id: id || attributes.layerConfig.id,
            active: layerId ? id === layerId : attributes["default"]
          }, attributes)]
        };
      });
    }
  }, {
    key: "getMapOptions",
    value: function getMapOptions() {
      var FROM_PROPS = {
        zoom: this.mapConfiguration.zoom || 2,
        lat: this.mapConfiguration.lat || 0,
        lng: this.mapConfiguration.lng || 0,
        bbox: this.mapConfiguration.bbox || [0, 0, 0, 0]
      };

      var mapOptions = _objectSpread({}, FROM_PROPS, {}, MAP_CONFIG);

      mapOptions.center = [this.mapConfiguration.lat || 0, this.mapConfiguration.lng || 0];
      return mapOptions;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props, _this$props$mapConfig;

      this.hasBeenMounted = true;
      this.instantiateMap();
      var mapOptions = this.getMapOptions(); // If the bounds are not defined, we set them in the store

      if (!((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$mapConfig = _this$props.mapConfig) === null || _this$props$mapConfig === void 0 ? void 0 : _this$props$mapConfig.bounds) || !mapOptions.hasOwnProperty("bbox")) {
        this.onMapChange();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var loadingChanged = this.state.loading !== nextState.loading;
      var captionChanged = this.props.caption !== nextProps.caption;
      var legendToggleChanged = this.state.legendOpen !== nextState.legendOpen;
      var basemapChanged = !(0, _isEqual["default"])(nextProps.mapConfiguration.basemap, this.props.mapConfiguration.basemap);
      var bboxChanged = !(0, _isEqual["default"])(nextProps.mapConfiguration.bbox, this.props.mapConfiguration.bbox);
      return loadingChanged || captionChanged || legendToggleChanged || basemapChanged || bboxChanged;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props$mapConfig2, _this$props$mapConfig3, _nextProps$mapConfigu, _nextProps$mapConfigu2, _this$props$mapConfig4, _this$props$mapConfig5, _nextProps$mapConfigu3, _nextProps$mapConfigu4;

      if (nextProps.layerId !== this.props.layerId) {
        var expectedLayerGroups = this.createLayerGroups(nextProps.layers, nextProps.layerId);
        var layers = expectedLayerGroups.filter(function (l) {
          return l.visible;
        }).map(function (l) {
          return l.layers.find(function (la) {
            return la.active;
          });
        }).filter(Boolean);
        this.layerManager.removeLayers();
        this.addLayers(layers);
      }

      if (((_this$props$mapConfig2 = this.props.mapConfiguration) === null || _this$props$mapConfig2 === void 0 ? void 0 : (_this$props$mapConfig3 = _this$props$mapConfig2.basemap) === null || _this$props$mapConfig3 === void 0 ? void 0 : _this$props$mapConfig3.labels) !== ((_nextProps$mapConfigu = nextProps.mapConfiguration) === null || _nextProps$mapConfigu === void 0 ? void 0 : (_nextProps$mapConfigu2 = _nextProps$mapConfigu.basemap) === null || _nextProps$mapConfigu2 === void 0 ? void 0 : _nextProps$mapConfigu2.labels)) {
        this.setLabels(_constants.LABELS[nextProps.mapConfiguration.basemap.labels]);
      }

      if (((_this$props$mapConfig4 = this.props.mapConfiguration) === null || _this$props$mapConfig4 === void 0 ? void 0 : (_this$props$mapConfig5 = _this$props$mapConfig4.basemap) === null || _this$props$mapConfig5 === void 0 ? void 0 : _this$props$mapConfig5.boundaries) !== ((_nextProps$mapConfigu3 = nextProps.mapConfiguration) === null || _nextProps$mapConfigu3 === void 0 ? void 0 : (_nextProps$mapConfigu4 = _nextProps$mapConfigu3.basemap) === null || _nextProps$mapConfigu4 === void 0 ? void 0 : _nextProps$mapConfigu4.boundaries)) {
        this.setBoundaries(nextProps.mapConfiguration.basemap.boundaries);
      } // Map bbox changed


      if (!(0, _isEqual["default"])(nextProps.changeBbox, this.props.changeBbox)) {
        var _nextProps$changeBbox = _slicedToArray(nextProps.changeBbox, 4),
            b0 = _nextProps$changeBbox[0],
            b1 = _nextProps$changeBbox[1],
            b2 = _nextProps$changeBbox[2],
            b3 = _nextProps$changeBbox[3];

        this.map.fitBounds([[b1, b0], [b3, b2]], {
          animate: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _mapConfiguration$bas;

      var mapConfiguration = this.props.mapConfiguration;

      if (!(0, _isEqual["default"])(this.basemap.basemap, mapConfiguration === null || mapConfiguration === void 0 ? void 0 : (_mapConfiguration$bas = mapConfiguration.basemap) === null || _mapConfiguration$bas === void 0 ? void 0 : _mapConfiguration$bas.basemap)) {
        this.basemap = _constants.BASEMAPS[mapConfiguration.basemap.basemap];
        this.setBasemap(this.basemap);
      }
    }
  }, {
    key: "isNullSetBBox",
    value: function isNullSetBBox(mapOptions) {
      return mapOptions.lat === 0 && mapOptions.lng === 0;
    }
  }, {
    key: "instantiateMap",
    value: function instantiateMap() {
      var _this$props$mapConfig6, _this$props$mapConfig7, _this$props2, _this$props2$mapConfi;

      if (!this.mapNode) return;
      var mapOptions = this.getMapOptions();
      this.map = L.map(this.mapNode, mapOptions);
      this.map.scrollWheelZoom.disable(); // Disable interaction if necessary

      if (!this.props.interactionEnabled) {
        this.map.dragging.disable();
        this.map.touchZoom.disable();
        this.map.doubleClickZoom.disable();
        this.map.boxZoom.disable();
        this.map.keyboard.disable();
      }

      this.map.attributionControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>');

      if (this.map.zoomControl) {
        this.map.zoomControl.setPosition("topright");
      }

      this.setBasemap(this.basemap);
      this.setEventListeners();
      this.instantiateLayerManager();
      var layers = this.layerGroups.filter(function (l) {
        return l.visible;
      }).map(function (l) {
        return l.layers.find(function (la) {
          return la.active;
        });
      }).filter(Boolean);
      this.activeLayers = layers;
      this.addLayers(layers);
      this.setLabels(this.labels);
      this.setBoundaries(((_this$props$mapConfig6 = this.props.mapConfiguration) === null || _this$props$mapConfig6 === void 0 ? void 0 : (_this$props$mapConfig7 = _this$props$mapConfig6.basemap) === null || _this$props$mapConfig7 === void 0 ? void 0 : _this$props$mapConfig7.boundries) || false); // In version2 of the editor we are storing the bbox
      // This is so in the future we can migrate to for example mapbox
      // If we have a bbox, this is automaticly saved in the new editor
      // We pan to it if present

      if (mapOptions.bbox && Array.isArray(mapOptions.bbox)) {
        var _mapOptions$bbox = _slicedToArray(mapOptions.bbox, 4),
            b0 = _mapOptions$bbox[0],
            b1 = _mapOptions$bbox[1],
            b2 = _mapOptions$bbox[2],
            b3 = _mapOptions$bbox[3];

        this.map.fitBounds([[b1, b0], [b3, b2]], {
          animate: false
        });
      } else if ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$mapConfi = _this$props2.mapConfig) === null || _this$props2$mapConfi === void 0 ? void 0 : _this$props2$mapConfi.bounds) {
        // Legacy editor stores "bounds"
        // Apply them instead if present
        this.map.fitBounds(this.props.mapConfig.bounds, {
          animate: false
        });
      }

      this.map.setZoom(mapOptions.zoom);
    }
  }, {
    key: "instantiateLayerManager",
    value: function instantiateLayerManager() {
      var _this2 = this;

      var stopLoading = function stopLoading() {
        // Don't execute callback if component has been unmounted
        if (!_this2.hasBeenMounted) return;

        _this2.setState({
          loading: false
        });
      };

      this.layerManager = new _layerManager["default"](this.map, {
        onLayerAddedSuccess: stopLoading,
        onLayerAddedError: stopLoading
      });
    }
    /**
     * Set the map's labels
     * @param {Label} labels Labels
     */

  }, {
    key: "setLabels",
    value: function setLabels(labels) {
      if (labels && this.labelsLayer) this.labelsLayer.remove();

      if (labels && labels.id !== 'none') {
        this.labelsLayer = L.tileLayer(labels.value, labels.options || {}).addTo(this.map).setZIndex(this.activeLayers.length + 1);
      }
    }
  }, {
    key: "addLayers",
    value: function addLayers(layers) {
      var _this3 = this;

      if (!layers) return;
      this.setState({
        loading: true
      });
      layers.forEach(function (layer) {
        _this3.layerManager.addLayer(layer, {
          zIndex: layer.order
        });
      });
    }
  }, {
    key: "getMapParams",
    value: function getMapParams() {
      var bounds = this.map.getBounds();
      var params = {
        zoom: this.map.getZoom(),
        latLng: this.map.getCenter(),
        basemap: this.props.mapConfiguration.basemap,
        labels: this.props.mapConfiguration.labels,
        bounds: [[bounds.getSouthWest().lat, bounds.getSouthWest().lng], [bounds.getNorthEast().lat, bounds.getNorthEast().lng]]
      };
      return params;
    }
  }, {
    key: "onMapChange",
    value: function onMapChange() {
      var _this$props3 = this.props,
          editorSyncMap = _this$props3.editorSyncMap,
          patchConfiguration = _this$props3.patchConfiguration;

      if (editorSyncMap) {
        var mapParams = this.getMapParams();
        var zoom = mapParams.zoom;
        var _mapParams$latLng = mapParams.latLng,
            lat = _mapParams$latLng.lat,
            lng = _mapParams$latLng.lng;

        var _mapParams$bounds = _slicedToArray(mapParams.bounds, 2),
            bbox1 = _mapParams$bounds[0],
            bbox2 = _mapParams$bounds[1];

        editorSyncMap({
          lat: lat,
          lng: lng,
          zoom: zoom,
          basemap: mapParams.basemap,
          bounds: mapParams.bounds,
          bbox: [].concat(_toConsumableArray(bbox1), _toConsumableArray(bbox2))
        });
        patchConfiguration();
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this4 = this;

      this.map.on("zoomend", function () {
        return _this4.onMapChange();
      });
      this.map.on("dragend", function () {
        return _this4.onMapChange();
      });
    }
  }, {
    key: "setBoundaries",
    value: function setBoundaries(showBoundaries) {
      if (this.boundariesLayer) this.boundariesLayer.remove();

      if (showBoundaries && this.activeLayers) {
        this.boundariesLayer = L.tileLayer(_constants.BOUNDARIES.dark.value, _constants.BOUNDARIES.dark.options || {}).addTo(this.map).setZIndex(this.activeLayers.length + 2);
      }
    }
  }, {
    key: "setBasemap",
    value: function setBasemap(basemap) {
      if (this.tileLayer) this.tileLayer.remove();
      this.tileLayer = L.tileLayer(basemap.value, basemap.options).addTo(this.map).setZIndex(0);
    }
  }, {
    key: "getLegendLayerTitle",
    value: function getLegendLayerTitle(legendConfig, lc) {
      if (legendConfig.type === "gradient") {
        return lc.unit;
      }

      if (legendConfig.type === "choropleth") {
        return lc.name;
      }
    }
  }, {
    key: "generateGradient",
    value: function generateGradient(items) {
      var scale = items.map(function (i) {
        return i.color;
      });
      var domain = items.map(function (i) {
        return i.value;
      });
      return _chromaJs["default"].scale(scale).domain(domain).colors(items.length);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props4 = this.props,
          _this$props4$caption = _this$props4.caption,
          caption = _this$props4$caption === void 0 ? null : _this$props4$caption,
          _this$props4$thumbnai = _this$props4.thumbnail,
          thumbnail = _this$props4$thumbnai === void 0 ? false : _this$props4$thumbnai,
          layerId = _this$props4.layerId;
      return (
        /*#__PURE__*/
        _react["default"].createElement(_styles.StyledMapContainer, null,
        /*#__PURE__*/
        _react["default"].createElement(_vizzualityComponents.Icons, null), caption &&
        /*#__PURE__*/
        _react["default"].createElement(_styles.StyledCaption, null, caption), !thumbnail &&
        /*#__PURE__*/
        _react["default"].createElement(StyledLegend, null,
        /*#__PURE__*/
        _react["default"].createElement(_vizzualityComponents.Legend, {
          maxHeight: 140,
          sortable: false
        }, this.layerGroups.filter(function (lg) {
          return lg.layers.find(function (l) {
            return l.id === layerId;
          });
        }).map(function (lg, i) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_vizzualityComponents.LegendListItem, {
              index: i,
              key: lg.dataset,
              layerGroup: lg
            },
            /*#__PURE__*/
            _react["default"].createElement(_vizzualityComponents.LegendItemTypes, null))
          );
        }))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          ref: function ref(node) {
            _this5.mapNode = node;
          },
          className: "map-leaflet"
        }))
      );
    }
  }]);

  return Map;
}(_react["default"].Component);

var _default = _shared.redux.connectState(function (state) {
  return {
    configuration: state.configuration
  };
}, {
  editorSyncMap: _actions.editorSyncMap,
  patchConfiguration: _actions2.patchConfiguration
})(Map);

exports["default"] = _default;